require("./o-region-map.scss");

// JavaScript
var $ = $ = require("jquery"),
    RegionMapCtrl = require("./RegionMapCtrl.js");

$('.o-region-map__map').each(function () {
    new RegionMapCtrl(this);
});


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-region-map/o-region-map.chunk.js